module.exports = __webpack_public_path__ + "static/12-50dcaaabeb604f2b6aedfae3620c37c9.jpg";